import { render, staticRenderFns } from "./OtherChangesCard.vue?vue&type=template&id=260edb59&"
import script from "./OtherChangesCard.vue?vue&type=script&lang=ts&"
export * from "./OtherChangesCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports